import React, { useEffect, useState, useRef } from "react";
import Axios from 'axios';
import '../../App.css';
import DynamicSelect from "./DynamicSelect";
import RangeSlider from "./RangeSlider";
import { Copy, Save, Check, Sparkles, Lock } from "lucide-react";
import { pickLookalike } from "./lookalikes";
import { Link } from "react-router-dom";

export default function Create(props) {

const [search, setSearch] = useState("");
const [originalSearch, setOriginalSearch] = useState("");
const [output, setOutput] = useState('');
const [rangeValue, setRangeValue] = useState(50);
const [loginStatus, setLoginStatus] = useState();
const [type, setType] = useState(""); 

//axios.defaults.withCredentials = true;

const [isHidden, setIsHidden] = useState(false);
// idle | scanning | copied
const [copyState, setCopyState] = useState('idle');

      const handleClick = () => {
        if (copyState !== 'idle') return;
        navigator.clipboard.writeText(output);
        setCopyState('scanning');
        setTimeout(() => setCopyState('copied'), 280);
        setTimeout(() => setCopyState('idle'), 2300);
      };

      const saveClick = () => {
        console.log(props.uEmail);
        if(output.length > 3){
          Axios.post("https://mygamename.com/php/save.php", {
            email: props.uEmail,
            name: output,
          }).then((response) => {
            console.log(response);
            setType('saved');
            setIsHidden(!isHidden);  
          });
        }
      };

      useEffect(() => {
        const fetchProtected = async () => {
          try {
            const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
            console.log(response);
            if (response.data.status === 'success') {
              //setEmail(response.data.email);
              setLoginStatus(true);
              props.setUEmail(response.data.email);
            } else {
              //window.location.href = '/login';
            }
          } catch (error) {
            console.error(error);
            //window.location.href = '/login';
          }
        };
      
        fetchProtected();
      }, []);

  return (
    <div className="mx-auto max-w-2xl py-12 px-4 flex flex-col gap-6">

      <h1 className="text-4xl text-center font-extrabold tracking-tight text-[#F5F5F5] md:text-5xl">Name Creator</h1>

      {/* Section 1 — Input */}
      <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5">
        <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold mb-3">Input</p>
        <input
          className="bg-[#111111] border border-[#333333] text-[#F5F5F5] text-sm rounded-lg focus:ring-[#8B5CF6] focus:border-[#8B5CF6] block w-full p-3 placeholder-[#F5F5F5]/30 outline-none transition-colors"
          type="text"
          placeholder="Type your game name…"
          value={search}
          onChange={(e) => { setSearch(e.target.value); setOriginalSearch(e.target.value); }}
        />
      </div>

      {/* Section 2 — Modifications */}
      <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5 min-h-[100px]">
        <div className="flex items-center justify-between mb-3">
          <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold">Modifications</p>
          {search && (
            <button
              onClick={() => setSearch((originalSearch || search).split('').map(pickLookalike).join(''))}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-[#8B5CF6]/40 bg-[#8B5CF6]/10 text-[#8B5CF6] text-xs font-semibold hover:bg-[#8B5CF6]/20 hover:border-[#8B5CF6] transition-colors"
            >
              <Sparkles size={13} />
              Auto
            </button>
          )}
        </div>
        {search ? (
          <DynamicSelect search={search} setSearch={setSearch} output={output} setOutput={setOutput} originalSearch={originalSearch}/>
        ) : (
          <p className="text-[#F5F5F5]/30 text-sm">Enter a name above to start modifying characters.</p>
        )}
      </div>

      {/* Section 3 — Output */}
      <div className="bg-[#1a1a1a] border border-[#222222] rounded-xl p-5">
        <p className="text-[#8B5CF6] text-xs uppercase tracking-widest font-semibold mb-3">Output</p>
        <div className="min-h-[48px] mb-4">
          {output ? (
            <p className="text-[#F5F5F5] text-2xl font-bold break-all">{output}</p>
          ) : (
            <p className="text-[#F5F5F5]/30 text-sm">Your modified name will appear here.</p>
          )}
        </div>
        <div className="flex gap-3">
          {props.loginStatus ? (
            <button
              onClick={saveClick}
              className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] bg-[#111111] text-[#F5F5F5] text-sm font-semibold hover:border-[#8B5CF6] hover:bg-[#8B5CF6]/10 transition-colors"
            >
              <Save size={16} />
              Save
            </button>
          ) : (
            <Link
              to="/login"
              className="group relative flex items-center gap-2 px-5 py-2.5 rounded-lg border border-[#333333] bg-[#111111] text-[#F5F5F5]/30 text-sm font-semibold cursor-pointer hover:border-[#8B5CF6]/50 transition-colors"
              title="Sign in to save names"
            >
              <Lock size={14} className="group-hover:text-[#8B5CF6] transition-colors" />
              <span className="group-hover:text-[#F5F5F5]/60 transition-colors">Save</span>
              <span className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap text-[10px] text-[#F5F5F5]/50 bg-[#111111] border border-[#333333] px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
                Sign in to save
              </span>
            </Link>
          )}
          <button
            onClick={handleClick}
            className={`relative overflow-hidden w-full py-3 rounded-lg text-sm font-semibold border border-[#8B5CF6] text-[#F5F5F5] bg-[#8B5CF6] transition-colors ${
              copyState === 'idle'    ? 'copy-btn-idle cursor-pointer' :
              copyState === 'copied'  ? 'copy-btn-copied cursor-default' :
              'cursor-default'
            }`}
          >
            {copyState === 'idle'    && <span className="copy-shimmer" />}
            {copyState === 'scanning' && <span className="copy-scan" />}
            <span className={`flex items-center justify-center gap-2 transition-all duration-200 ${
              copyState === 'scanning' ? 'opacity-0 scale-95' : 'opacity-100 scale-100'
            }`}>
              {copyState === 'copied' ? <Check size={15} strokeWidth={3} /> : <Copy size={15} />}
              {copyState === 'copied' ? 'Locked in' : 'Copy Name'}
            </span>
          </button>
        </div>
        <div id="copiedText" className={isHidden ? 'mt-3' : 'hidden'}>
          <p className="text-sm text-[#F5F5F5] rounded-lg bg-[#111111] border border-[#8B5CF6]/40 p-3">
            <span className="font-medium text-[#8B5CF6]">Done!</span> The name has been {type}.
          </p>
        </div>
      </div>

    </div>
  );
}